const config = {
  mainFacility: '9878e975-d060-430b-a59e-e65fd57628fc',
  googlePlaceId: 'ChIJexSN7DiLGGARcV-_JHR9AKY',
  assetsBucketUrl: 'https://s3.ap-northeast-1.amazonaws.com/net.cocodakara.bodydesign-dev.assets/',
  recaptchaSiteKey: '6Le5swwtAAAAAFl-g_BbcTcXHcSRoHI_KJvy0ai9',
  v2PathPatternsToReload: [
    '/',
    '/terms-of-service',
    '/privacy-policy',
    '/faq',
    '/price',
    '/gallery',
    '/sign-in*',
    '/welcome*',
    '/verify*',
    '/403',
    '/account-unavailable*',
    '/my-page*',
    '/profile*',
    '/articles*',
    '/training-plan*',
    '/admin',
    '/admin/**',
  ],
};

export default config;
